(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-rows.js');
"use strict";

const _svs$components$tipse = svs.components.tipsen.tipsinfo,
  AnalysisForecast = _svs$components$tipse.AnalysisForecast,
  TipsinfoRow = _svs$components$tipse.TipsinfoRow,
  TipsinfoRowStats = _svs$components$tipse.TipsinfoRowStats;
const _svs$components$tipse2 = svs.components.tipsen.tipsinfo.utils,
  formatDecimalOdds = _svs$components$tipse2.formatDecimalOdds,
  formatPercentage = _svs$components$tipse2.formatPercentage,
  getOddsCaption = _svs$components$tipse2.getOddsCaption;
const Trend = svs.components.lbUi.trend.Trend;
const TipsinfoRows = _ref => {
  let layOutProps = _ref.layOutProps;
  const drawNumber = layOutProps.drawNumber,
    eventNumber = layOutProps.eventNumber,
    favourites = layOutProps.favourites,
    hasTioTidningarValues = layOutProps.hasTioTidningarValues,
    hasTipsinfoStats = layOutProps.hasTipsinfoStats,
    isGoalCount = layOutProps.isGoalCount,
    isReduceFree = layOutProps.isReduceFree,
    isResultOrMybets = layOutProps.isResultOrMybets,
    isStartOddsEnabled = layOutProps.isStartOddsEnabled,
    matchId = layOutProps.matchId,
    outcomeLabels = layOutProps.outcomeLabels,
    productId = layOutProps.productId,
    selectFormattedDistribution = layOutProps.selectFormattedDistribution,
    selectFormattedOdds = layOutProps.selectFormattedOdds,
    shouldDisplayFavourites = layOutProps.shouldDisplayFavourites,
    shouldDisplayLargeTipsinfo = layOutProps.shouldDisplayLargeTipsinfo,
    shouldDisplayOdds = layOutProps.shouldDisplayOdds,
    shouldDisplayStartOdds = layOutProps.shouldDisplayStartOdds,
    shouldDisplaySvenskaFolket = layOutProps.shouldDisplaySvenskaFolket,
    shouldDisplayTioTidningar = layOutProps.shouldDisplayTioTidningar,
    showMatchAnalyseForecast = layOutProps.showMatchAnalyseForecast,
    startOdds = layOutProps.startOdds,
    tioTidningarTips = layOutProps.tioTidningarTips;
  return React.createElement("div", {
    className: "tipsinfo tipsinfo-".concat((outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.length) || '0', "col")
  }, isReduceFree && hasTipsinfoStats && React.createElement(TipsinfoRow, {
    className: "tipsinfo-bet-options-headers",
    dataTestid: "coupon-row-tipsinfo-bet-options-headers"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map(el => React.createElement("div", {
    className: "f-center",
    key: el.text
  }, el.text)))), shouldDisplaySvenskaFolket && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-svenska-folket",
    title: "Svenska folket"
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    postfixSymbol: "%",
    selectorFunction: selectFormattedDistribution(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-odds",
    title: getOddsCaption({
      isStartOddsEnabled,
      isResultOrMybets
    })
  }, React.createElement("div", {
    className: "tipsinfo-statistics-grid"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((el, i) => React.createElement(Trend, {
    key: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text),
    selectorFunction: selectFormattedOdds(i),
    uniqueId: "".concat(drawNumber, "_").concat(matchId, "_").concat(el.text)
  })))), shouldDisplayFavourites && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-favourites",
    title: "Favoritskap"
  }, React.createElement(TipsinfoRowStats, {
    className: shouldDisplayLargeTipsinfo ? 'tipsinfo-row-stats-option--lg' : '',
    sign: "%"
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _favourites$current;
    return formatPercentage(favourites === null || favourites === void 0 || (_favourites$current = favourites.current) === null || _favourites$current === void 0 ? void 0 : _favourites$current.value[i]);
  }))), shouldDisplayStartOdds && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-start-odds",
    title: "Startodds"
  }, React.createElement(TipsinfoRowStats, null, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _startOdds$current;
    return formatDecimalOdds(startOdds === null || startOdds === void 0 || (_startOdds$current = startOdds.current) === null || _startOdds$current === void 0 ? void 0 : _startOdds$current.value[i]);
  }))), shouldDisplayTioTidningar && React.createElement(TipsinfoRow, {
    dataTestid: "coupon-row-tips-info-ten-papers",
    title: "Tio Tidningar"
  }, React.createElement(TipsinfoRowStats, {
    noValueSign: hasTioTidningarValues ? '0' : '-'
  }, outcomeLabels === null || outcomeLabels === void 0 ? void 0 : outcomeLabels.map((_, i) => {
    var _tioTidningarTips$cur;
    return tioTidningarTips === null || tioTidningarTips === void 0 || (_tioTidningarTips$cur = tioTidningarTips.current) === null || _tioTidningarTips$cur === void 0 ? void 0 : _tioTidningarTips$cur.value[i];
  }))), showMatchAnalyseForecast && isGoalCount && React.createElement("div", {
    className: "tipsinfo-border-fulltraff"
  }), showMatchAnalyseForecast && React.createElement(AnalysisForecast, {
    dataTestid: "coupon-row-tips-info-analyse",
    drawId: drawNumber,
    eventNumber: eventNumber,
    matchId: matchId,
    productId: productId
  }));
};


setGlobal('svs.components.tipsen.tipsinfo.TipsinfoRows', TipsinfoRows);

 })(window);